import {Box, P, Span} from 'exsportia-components'
import React, {FC} from 'react'

import {SUBSCRIPTION_PRICE_TYPE_MAP} from '../../../api/subscriptions/constants'
import {useVenue} from '../../../api/venue/hooks'
import {LabeledValueRow} from '../../../ui/components/key-value-row/labeled-value-row'
import {useLocale} from '../../../utils/i18n'
import {useSubscriptionPaymentOptions} from './use-subscription-payment-options'

type Props = {
  subscriptionId: string
}

export const PaymentOptionsList: FC<Props> = ({subscriptionId}) => {
  const {l} = useLocale()
  const paymentOptions = useSubscriptionPaymentOptions(subscriptionId)

  const {data: venue} = useVenue({})

  if (!venue) {
    return null
  }

  return (
    <Box>
      <LabeledValueRow
        label={l('paymentOptions')}
        align={'flex-start'}
      >
        {
          paymentOptions.map(option => (
            <P mb={'8px'} textAlign={'right'}>
              <Span>
                <Span color={'primary'}>
                  {l(`${venue.currency}_symbolic`, {value: option.price})}
                </Span>
                <Span ml={'8px'}>
                  {l(SUBSCRIPTION_PRICE_TYPE_MAP[option.type].label)}
                </Span>
              </Span>
            </P>
          ))
        }
      </LabeledValueRow>
    </Box>
  )
}